
import { VehicleValidation } from "./vehicle-validation";
import { ValidationCriterion } from "./validation-criterion";
import { DynamicField } from "./dynamic-field";

export interface FleetChecklist {
  id: string;
  name: string;

  status: FleetStatus;
  createdAt: Date;
  type: string; // externo o interno
  updatedAt?: Date;
  sendetAt?: Date;
  deletedAt?: Date;

  tags?: string[];
  vehicles: VehicleValidation[];
  criteria: ValidationCriterion[];
  fields: DynamicField[];
  parameters?: { [key: string]: any };
}
export type FleetChecklistSummary = Omit<
  FleetChecklist, 'vehicles' | 'criteria'
> & {
  vehiclesIds: string[];
};


export type FleetChecklistCreate = {
  name: string;
  status: FleetStatus;
  type: string;
  vehiclesIds: string[];
  date?: string;
  fields?: DynamicField[];
  tags?: string[];
  parameters?: { [key: string]: any };
};
export type FleetChecklistUpdate = Partial<FleetChecklist> & {
  vehiclesIds?: string[];
};;
export type FleetChecklistBaseUpdate =  Partial<FleetChecklist> & {
  vehiclesIds: string[];
};


export enum FleetStatus {
  IN_PROGRESS = 'pending',
  COMPLETED = 'completed',
  SENT = 'sent'
}

export enum FleetChecklistType {
  INTERNO = 'interno',
  EXTERNO = 'externo',
  DIAZ = 'diaz',
  MOVILBUS = 'movilbus',
}

export type FleetGroupedByType = {
  type: string;
  items: FleetChecklistSummary[];
}

export type FleetGroupedByTime = {
  label: string;
  isToday: boolean;
  groups: FleetGroupedByType[];
}
